// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

export { default } from './Spinner';



// WEBPACK FOOTER //
// ./components/Spinner/index.js